import { render } from "./settingsDrawer.vue?vue&type=template&id=bcc51800&scoped=true"
import script from "./settingsDrawer.vue?vue&type=script&lang=js"
export * from "./settingsDrawer.vue?vue&type=script&lang=js"

import "./settingsDrawer.vue?vue&type=style&index=0&id=bcc51800&scoped=true&lang=css"
import "./settingsDrawer.vue?vue&type=style&index=1&id=bcc51800&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcc51800"]])

export default __exports__